import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import Confirm from "../../Modal/Confirm";

const OptionsPopup = ({ actions, index, className }) => {
  useEffect(() => {});

  return (
    <div className={className}>
      {actions.map((action, idx) => (
        // <Confirm
        //   key={idx}
        //   title="Override Button Style"
        //   confirmMessage={`Are you sure you want to delete?`}
        //   getConfirmation={(status) => {
        //     status && action.onClick(index);
        //   }}
        // >
        <div
          key={idx}
          onDragStart={(e) => e.preventDefault()}
          onMouseDown={(e) => {
            e.preventDefault();

            action.onClick(index);
          }}
        >
          {action.name}

          <img
            onDragStart={(e) => e.preventDefault()}
            className={action.name}
            src={action.icon}
            alt={action.name}
          />
        </div>
        // </Confirm>
      ))}
    </div>
  );
};

OptionsPopup.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  index: PropTypes.string.isRequired,
};

export default OptionsPopup;
